import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {AuthenticatedBaseComponent} from '../../../authenticated-base.component';
import {TableComponent} from '../../../../components/table/table.component';

@Component({
  selector: 'app-authenticated-time-tracking-absence-requests-absences',
  templateUrl: './absences.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TableComponent]
})
export class AbsencesComponent extends AuthenticatedBaseComponent implements OnInit {
  public ngOnInit() {
    this.titleService.setTitle('authenticated.time_tracking.absence_requests.absences.title');
  }
}
